import { COLLABORATORS_HOME_ROUTE } from './auth';
import { TRANSLATIONS_HOME } from '../translations/home';

export const COLLABORATORS_CARD_TEXTS = {
  active: {
    title: TRANSLATIONS_HOME.collaboratorsCard.active.title,
    description: TRANSLATIONS_HOME.collaboratorsCard.active.description,
    button: TRANSLATIONS_HOME.collaboratorsCard.active.button,
    redirect: ''
  },
  invited: {
    title: TRANSLATIONS_HOME.collaboratorsCard.invited.title,
    description: TRANSLATIONS_HOME.collaboratorsCard.invited.description,
    button: TRANSLATIONS_HOME.collaboratorsCard.invited.button,
    redirect: ''
  },
  pending: {
    title: TRANSLATIONS_HOME.collaboratorsCard.pending.title,
    description: TRANSLATIONS_HOME.collaboratorsCard.pending.description,
    button: TRANSLATIONS_HOME.collaboratorsCard.pending.button,
    redirect: COLLABORATORS_HOME_ROUTE
  }
};

export const TEMPLATE_BANNER_NE_TYPES = {
  whiteCurve: 'white-curve',
  pinkSquare: 'pink-square',
  whiteSquare: 'white-square',
  greenGreySquare: 'green-grey-square'
};

export const CAROUSEL_INTERVAL = 5000;

export const SKELETON_COMPONENT_CLASSES = [
  'first-component df',
  'second-component',
  'third-component',
  'fourth-component',
  'fifth-component'
];
